import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum SalesCasePotentialId {
  HIGH = 'high',
  LOW = 'low',
  NOT_SPECIFIED = 'none',
}

export class SalesCasePotential extends Codebook<SalesCasePotentialId> {
  static readonly HIGH = new SalesCasePotential(
    SalesCasePotentialId.HIGH,
    () => $t('High'),
    'chevron-up',
    Color.INFO_STATE,
  )

  static readonly LOW = new SalesCasePotential(
    SalesCasePotentialId.LOW,
    () => $t('Low'),
    'chevron-down',
    Color.GREY_500,
  )

  static readonly NOT_SPECIFIED = new SalesCasePotential(
    SalesCasePotentialId.NOT_SPECIFIED,
    () => $t('Not specified'),
    'ban',
    Color.WARNING_STATE,
  )

  private constructor(
    id: SalesCasePotentialId,
    public readonly name: () => string,
    public readonly icon: string,
    public readonly color: Color,
  ) {
    super(id)
  }
}
